module.exports = __webpack_public_path__ + "images/banners/pages_iphone/iphone-page-mock2_0b00d5ab84e1af72facece6073189e35.png";